<style>
.price-inside-prod .content-box {
  padding: 0px !important;
  margin: 0px !important;
}

.price-inside-prod .todo-content {
  padding: 0px !important;
  margin: 0px !important;
}

.price-inside-prod .all-tasks-w {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>
<template>
  <div class="todo-app-w" :class="{ 'price-inside-prod': sku_p != null }">
    <div class="col-12 content-box">
      <div class="row">
        <div class="col-sm-12">
          <div class>
            <div class="element-header">
              <router-link :to="{
                name: 'cat-productos-precios',
                params: { sku: current.sku },
              }">
                <a style="color: #0264b5; font-size: 13px;">
                  <i class="fas fa-angle-double-left"></i> Regresar a Precios por Lista
                </a>
              </router-link>
              <router-link :to="{
                name: 'compras-lista-precios-compras',
                params: { sku: current.sku },
              }" style="float: right;">
                <a style="color: #0264b5; font-size: 13px;">
                  Ir a Precios de Compras <i class="fas fa-angle-double-right"></i>
                </a>
              </router-link>
            </div>
            <br>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="element-wrapper">
            <div class="todo-content">
              <h4 class="todo-content-header" style="color: black;">
                <span>Análisis de Precios</span>
                <br>
                <span>{{ current.sku }} - {{ current.nombre }}</span>
              </h4>
              <div class="status-pill green" data-title="Activo" data-toggle="tooltip" data-original-title title></div>
              <span>Precios Activos</span>&nbsp;
              <br />
              <div class="status-pill red" data-title="Activo" data-toggle="tooltip" data-original-title title></div>
              <span>Precios Inactivos</span>
              <br />

              <div class="all-tasks-w">
                <div class="tasks-section">
                  <div class="tasks-header-w">
                    <h5 class="tasks-header">
                      Costo Global Unitario: Q {{ redondearDosDecimales(current.ultimo_costo) }}
                    </h5>
                  </div>
                </div>
                <div class="tasks-section">
                  <!--END - TASKS HEADER-->
                  <div class="tasks-list-w">
                    <div class="table-responsive">
                      <table class="table table-bordered table-lg table-v2 table-striped">
                        <thead>
                          <tr>
                            <th>Lista Precio</th>
                            <th colspan="3" class="text-center" v-for="um in current.productounidadmedida_set" 
                              :key="um.id">
                              {{ um.unidad_medida.nombre }}
                              <br>
                              Unidades:
                              {{ um.unidad_medida.cantidad_unidades }}
                            </th>
                          </tr>
                        </thead>
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th class="text-center" v-for="(d, index) in columnas" :key="index">
                              <span>{{ d }}</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="l_precio in listas_de_precios" :key="l_precio.pk"
                            v-if="l_precio.id !== 5 && l_precio.id !== 13 && l_precio.estatus == true">
                            <td class="nowrap">
                              {{ l_precio.nombre }}
                            </td>
                            <td class="nowrap text-right" v-for="(valor, index) in getListaPrecio(
                              l_precio,
                              true
                            )" :key="index">
                              {{ valor === "0" ? "-" : valor }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!--END - Tasks List-->
              </div>
              <div v-if="agregar">
                <AgregarPrecioModalComponent v-if="current.sku != null && lista_precio_actual != null"
                  :lista_precio="lista_precio_actual" :producto="current" @cerrandomodal="refreshProducto" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal - Edit Task-->
    <div aria-hidden="true" class="modal fade" id="modal-historial" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document" v-if="precio_actual != null">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <div class="modal-title">
              <span>Sku: {{ current.sku }}</span>
              <span>Producto:</span>
              <strong>{{ current.nombre }}</strong>
            </div>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-title">
              <span>Lista de Precio: {{ precio_actual.lista_precio.nombre }}</span>&nbsp;
              <span>Unidad Medida:</span>
              <strong>{{ precio_actual.unidad_medida.nombre }}</strong>
            </div>
            <br />
            <table class="table table-compact">
              <thead>
                <tr>
                  <th>Rangos de Fechas</th>
                  <th class="text-right">Cálculo</th>
                  <th class="text-right">Margen</th>
                  <th class="text-right">Costo</th>
                  <th class="text-right">Precio Venta</th>
                  <th class="text-center">Modificación</th>
                  <th class="text-center">Usuario Modificó</th>
                  <th class="text-center"></th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="_hist in historial">
                  <td>
                    <span>{{ _hist.valido_desde }}</span>
                    <i class="os-icon os-icon-repeat icon-separator"></i>
                    <span>{{ _hist.valido_hasta }}</span>
                  </td>
                  <td class="text-right text-bright">
                    {{ _hist.tipo_calculo }}
                  </td>
                  <td class="text-right text-bright">
                    <span v-if="_hist.tipo_calculo == 'FIJO'">Q</span>
                    {{ _hist.margen }}
                    <span v-if="_hist.tipo_calculo == 'PORC'">%</span>
                  </td>
                  <td class="text-right text-bright">Q {{ _hist.costo }}</td>
                  <td class="text-right" :class="{ 'text-success': _hist.precio > _hist.costo }">
                    Q {{ _hist.precio }}
                  </td>
                  <td class="text-right">
                    {{ _hist.fecha_modificacion }}
                  </td>
                  <td class="text-right">
                    <UsuarioEnTablaComponent v-if="_hist.usuario_modificacion" :current="_hist.usuario_modificacion" />
                  </td>
                  <td>
                    <div v-if="_hist.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"
                      data-original-title title></div>
                    <div v-if="!_hist.estatus" class="status-pill red" data-title="Activo" data-toggle="tooltip"
                      data-original-title title></div>
                  </td>
                  <td>
                    <button v-if="_hist.estatus" @click="cambiarEstatus(_hist)" type="button"
                      class="btn btn-sm btn-warning">
                      Inactivar
                    </button>
                    <button v-if="!_hist.estatus" @click="cambiarEstatus(_hist)" type="button"
                      class="btn btn-sm btn-success">
                      Activar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer buttons-on-left">
            <button class="btn btn-link" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ProductosService from "@/services/catalogos/ProductosService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import AgregarPrecioModalComponent from "@/components/cat/productos/AgregarPrecioModalComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    AgregarPrecioModalComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      editando: false,
      sku: null,
      agregar: false,
      listas_de_precios: [],
      lista_precio_actual: null,
      current: {
        pk: null,
        errors: {},
        precios: [],
      },
      historial: [],
      precio_actual: null,
    };
  },
  props: ["sku_p"],
  computed: {
    columnas: function () {
      let self = this;
      let d = [];
      if (!self.current.productounidadmedida_set) {
        return d;
      }
      self.current.productounidadmedida_set.forEach(function (um) {
        d.push("Precio");
        d.push("% Margen");
        d.push("Precio Uni");
      });
      return d;
    },
  },
  mounted() {
    let self = this;
    self.refreshListasDePrecios();
    if (self.$route.params.sku) {
      self.sku = self.$route.params.sku;
    }
    if (self.sku_p) {
      self.sku = self.sku_p;
    }
    self.refreshProducto();
  },
  methods: {
    getListaPrecio(lp, activos) {
      let self = this;
      var d = [];
      if (!self.current.productounidadmedida_set) {
        return d;
      }
      self.current.productounidadmedida_set.forEach(function (um) {
        var agregado = false;

        let precioEncontrado = self.current.lista_precios.find(item => {
          return item.unidad_medida.id === um.unidad_medida.id && item.lista_precio.id === lp.id;
        });

        self.current.lista_precios.forEach(function (item, index) {
          if (
            item.unidad_medida.id == um.unidad_medida.id &&
            item.lista_precio.id == lp.id
          ) {
            if (activos) {
              d.push("Q " + item.precio);
              d.push(item.margen + "%");
              d.push("Q " + item.precio_unitario);
            }
            agregado = true;
          }
        });

        if (!agregado && activos) {
          d.push("0");
          d.push("0.00%");
          d.push("Q 0.00");
        }

        if (activos == false) {
          if (!agregado) {
            d.push("-");
            d.push("-");
            d.push("-");
          }
        }
      });
      return d;
    },
    refreshProducto() {
      let self = this;
      self.agregar = false;
      ProductosService.getById(self.sku).then((response) => {
        self.current = response.data;
        self.current.errors = [];
        self.current.pk = self.current.sku;
      });
    },
    refreshListasDePrecios() {
      let self = this;
      ListaPreciosService.fetch({
        quitar_paginacion: true,
      }).then((response) => {
        self.listas_de_precios = response.data;
      });
    },
    toggleSection(event) {
      $(event.target)
        .closest(".tasks-section")
        .find(".tasks-list-w")
        .slideToggle(100);
    },
    refreshHistorial() {
      let self = this;
      ProductosService.precios({
        producto: self.current.sku,
        lista_precio: self.precio_actual.lista_precio.id,
        unidad_medida: self.precio_actual.unidad_medida.id,
        quitar_paginacion: true,
        historial: true,
      }).then((response) => {
        self.historial = response.data;
      });
    },
    verHistorialDePrecio(precio) {
      let self = this;
      self.precio_actual = precio;
      self.refreshHistorial();
      $("#modal-historial").show();
    },
    cambiarEstatus(c) {
      let self = this;
      ProductosService.cambiar_estatus_a_precio(c.id).then((response) => {
        self.refreshHistorial();
        self.refreshProducto();
      });
    },
    redondearDosDecimales(valor) {
      if (!valor) return 0;
      return Math.round(valor * 100) / 100;
    },
  },
};
</script>
